// Gamification Types - Badges, Achievements & Streaks

export type BadgeCategory = 'leads' | 'page_views' | 'todos' | 'streak';
export type BadgeTier = 1 | 2 | 3 | 4;

export interface BadgeDefinition {
  id: string;
  category: BadgeCategory;
  name: string;
  description: string | null;
  icon: string;
  tier: BadgeTier;
  threshold: number;
  created_at: string;
}

export interface UserBadge {
  id: string;
  user_id: string;
  badge_id: string;
  earned_at: string;
  badge?: BadgeDefinition;
}

export interface UserStreak {
  user_id: string;
  current_streak: number;
  longest_streak: number;
  last_active_date: string | null;
  updated_at: string;
}

export interface UserLoginSession {
  id: string;
  user_id: string;
  login_date: string;
  created_at: string;
}

export interface GamificationStats {
  totalLeads: number;
  totalPageViews: number;
  totalCompletedTodos: number;
  currentStreak: number;
  longestStreak: number;
}

export interface BadgeProgress {
  badge: BadgeDefinition;
  current: number;
  earned: boolean;
  earnedAt?: string;
}

export interface CategoryProgress {
  category: BadgeCategory;
  badges: BadgeProgress[];
  currentValue: number;
}

// UI Labels
export const TIER_LABELS: Record<BadgeTier, string> = {
  1: 'Bronze',
  2: 'Silber',
  3: 'Gold',
  4: 'Platin',
};

export const TIER_COLORS: Record<BadgeTier, { bg: string; text: string; border: string }> = {
  1: { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-400', border: 'border-amber-300 dark:border-amber-700' },
  2: { bg: 'bg-slate-100 dark:bg-slate-700/50', text: 'text-slate-600 dark:text-slate-300', border: 'border-slate-300 dark:border-slate-600' },
  3: { bg: 'bg-yellow-100 dark:bg-yellow-900/30', text: 'text-yellow-700 dark:text-yellow-400', border: 'border-yellow-400 dark:border-yellow-600' },
  4: { bg: 'bg-violet-100 dark:bg-violet-900/30', text: 'text-violet-700 dark:text-violet-400', border: 'border-violet-400 dark:border-violet-600' },
};

export const CATEGORY_LABELS: Record<BadgeCategory, string> = {
  leads: 'Lead-Generierung',
  page_views: 'Website-Besuche',
  todos: 'Aufgaben erledigt',
  streak: 'Login-Streak',
};

export const CATEGORY_ICONS: Record<BadgeCategory, string> = {
  leads: 'UserPlus',
  page_views: 'Eye',
  todos: 'CheckCircle',
  streak: 'Flame',
};
